import React from 'react';
import { NodeProps, useReactFlow } from 'reactflow';
import { Main, Styled } from './style';
import { SettingsBlock, settingsDataType } from '../../../../settingsBlock';
import { IoCheckmarkCircleOutline, IoWarningOutline } from 'react-icons/io5';
import { ExpandedBlock } from '../../../expanded';
import { operationType, selectDataType } from '../../../../../services/types';
import { updateNodeValue } from '../../../../../services/method';
import { Select } from '../../../../form/select';
import { Textarea } from '../../../../form/textarea';
import { TextInput } from '../../../../form/textInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

type EditFieldsProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function EditFields({ id, data, setChildMinimize, setChildSettings }: EditFieldsProps) {
   const [modes, setModes] = React.useState<selectDataType[]>([
      { id: 1, name: 'Manual Mapping', refId: 'manual', isActive: true },
      { id: 2, name: 'JSON', refId: 'json', isActive: false }
   ]);
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   const { setNodes } = useReactFlow();
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   React.useEffect(() => {
      // eslint-disable-next-line no-useless-escape
      if (!data.value) updateNodeValue(id, setNodes, { mode: modes[0].refId, jsonItems: [{ key: '', value: '' }], jsonValue: '{\n  \"my_field_1\": \"value\",\n  \"my_field_2\": 1,\n  \"my_field_3\": true\n}'});
      else setModes(modes => modes.map(mode => ({ ...mode, isActive: mode.refId === data.value.mode })));
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   // ---
   const handleSelectModel = (selectId: number) => {
      setModes((modes) => modes.map((mode) => {
         if (mode.id === selectId) return { ...mode, isActive: true };
         else return { ...mode, isActive: false };
      }));
      updateNodeValue(id, setNodes, { mode: modes.find(m => m.id === selectId)?.refId });
   }

   // ---
   const handleItemChange = (index: number, keyRef: string, value: string) => {
      updateNodeValue(id, setNodes, { 
         jsonItems: data.value.jsonItems.map((item: any, inx: number) => {
            if (index === inx) return { ...item, [keyRef]: value };
            else return item;
         })
      });
   }

   // ---
   const isWarning = false;
   
   return (<>
      <SettingsBlock nodeId={ id } data={ settings } setData={ setSettings } />
      <Main>
         { isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ minWidth: '380px' }}
         ><Styled>
            <Select data={ modes } handleSelectItem={ handleSelectModel } isSmall={ true } />
            { data.value?.mode === 'manual' ? <>
               <button 
                  className="btn1" 
                  style={{ backgroundColor: data.background }}
                  onClick={ _=> updateNodeValue(id, setNodes, { jsonItems: [...data.value.jsonItems, { key: '', value: '' }] }) }
               >
                  Add Field
               </button>
               <div className="scroll">{
                  data.value.jsonItems?.map((item: { key: string, value: string }, index: number) => (
                     <div key={ index.toString() } className="item">
                        <div className="flex">
                           <TextInput keyRef="key" placeholder="json_key" value={ item.key } handleChange={ e => handleItemChange(index, 'key', e.target.value) } />
                           { index ? <div 
                              className="remove"
                              onClick={ _=> updateNodeValue(id, setNodes, { jsonItems: data.value.jsonItems.filter((_: any, inx: number) => inx !== index) }) }
                           >
                              <FontAwesomeIcon icon={ faTrashCan } />
                           </div> : null }
                        </div>
                        <TextInput keyRef="value" placeholder="json_value" value={ item.value } handleChange={ e => handleItemChange(index, 'value', e.target.value) } />
                     </div>
                  ))   
               }</div>
            </> : null}
            { data.value?.mode === 'json' ? 
               <Textarea 
                  placeholder="Write JSON data" 
                  value={ data.value?.jsonValue } 
                  handleChange={ e => updateNodeValue(id, setNodes, { jsonValue: e.target.value }) } 
               /> 
            : null }
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}